export const allowsSelfJoin = (board: {
  prefs?:
    | { isTemplate: boolean | null; selfJoin: boolean | null }
    | {
        isTemplate?: boolean;
        selfJoin?: boolean;
      }
    | null;
}): boolean => {
  return (board.prefs?.selfJoin ?? false) && !board.prefs?.isTemplate;
};
